import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';
import NavBar from '../components/nav-bar/Nav';
import SideBar from '../components/Sidebar';
import EmailGrab from '../components/Hero/EmailGrab';
import { ArrowLink } from '../components/Hero/HeroElements';
import { color, font, layout } from '../theme/tokens';

const Wrap = styled.main`
  display: flex;
  justify-content: center;
  background: ${color.paper};
  padding: 140px 0 160px;

  @media (max-width: 800px) {
    padding: 88px 0 104px;
  }
`;

const Inner = styled.div`
  width: 100%;
  max-width: ${layout.maxWidth};
  padding: 0 ${layout.gutter};

  @media (max-width: 800px) {
    padding: 0 ${layout.gutterMobile};
  }
`;

const Code = styled.p`
  font-family: ${font.body};
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: ${color.inkMuted};
  margin: 0 0 24px;
`;

const Title = styled.h1`
  font-family: ${font.display};
  color: ${color.green};
  font-size: 64px;
  font-weight: 400;
  letter-spacing: -0.015em;
  line-height: 1.1;
  margin: 0;
  max-width: 16ch;

  @media (max-width: 900px) { font-size: 44px; }
  @media (max-width: 480px) { font-size: 34px; }
`;

const Lede = styled.p`
  font-family: ${font.body};
  color: ${color.ink};
  font-size: 18px;
  line-height: 1.65;
  max-width: 52ch;
  margin: 28px 0 40px;
`;

export default function Page404() {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <Helmet>
        <title>Page not found | Vitalforce</title>
      </Helmet>

      <SideBar $isopen={isOpen} toggle={toggle} />
      <NavBar toggle={toggle} />

      <Wrap>
        <Inner>
          <Code>Error 404</Code>
          <Title>This page doesn't exist.</Title>
          <Lede>
            The link may be out of date, or the address mistyped. Everything else is
            still where you left it.
          </Lede>
          <ArrowLink href="/">Back to home</ArrowLink>
        </Inner>
      </Wrap>

      <EmailGrab />
    </>
  );
}
